
import Vue from 'vue'

import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: resolve => require(['@/components/GameReplay.vue'], resolve)
  },
  { 
    path: '/foo', 
    component: resolve => require(['@/components/Foo.vue'], resolve)
  },
  { 
    path: '/bar', 
    component: resolve => require(['@/components/Bar.vue'], resolve)
  },
  {
    path: "/hero",
    component: resolve => require(['@/components/Hero.vue'], resolve)
  },
  {
    path: "/item",
    component: resolve => require(['@/components/Item.vue'], resolve)
  },
  {
    path: "/summoner",
    component: resolve => require(['@/components/Summoner.vue'], resolve)
  },
  {
    path: "/rune",
    component: resolve => require(['@/components/Rune.vue'], resolve)
  },
]

export default new VueRouter({
  mode: "history",
  routes: routes
})


